import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/poss/poss';
import PossGrid from './PossGrid';

const mstp = state => {
    return {
        ...state.poss,
        permisos: state.login.me.permisos
    }
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(PossGrid);
